import { accessRole } from "../../../../helpers/access_role";

import React, { Fragment, useState, useRef, useEffect, useMemo } from "react";
import apiResponse from "../../../../services/apiResponse";
import { Link } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";

import moment from "moment";

import IndexBloc from "./Blocs/IndexBlock";

import Select from "react-select";

import TableActiveComponent from "./Components/TableActiveComponent";
import PegawaiSideBar from "../../GlobalComponents/PegawaiSidebar";

const IndexView = (props) => {
  var employeeSeleted = JSON.parse(localStorage.getItem("employeeSelected"));

  var userdata = JSON.parse(localStorage.getItem("userdata"));

  var employee_categories_uuid = !accessRole("approve")
    ? userdata != null
      ? userdata.employee_categories_uuid
      : ""
    : employeeSeleted != null
    ? employeeSeleted.employee_categories_uuid
    : "";
  var role_id = parseInt(localStorage.getItem("currentRoleId") ?? 0, 10);

  let indexBloc = useMemo(() => new IndexBloc(), []);

  useEffect(() => {
    // get data unit
    indexBloc.configChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          setLoading(true);
          break;
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            console.log("config", response);
            if (response) {
              setConfigValue(response.config_value);
            }
            setLoading(false);
          }
          break;
        case apiResponse.ERROR:
          setLoading(false);
          break;
        default:
          break;
      }
    });

    indexBloc.fetchConfig({});

    return () => {
      indexBloc.configChannel?.unsubscribe();
    };
  }, []);

  const [activeTab, setactiveTab] = useState("1");
  const [fileUrl, setFileUrl] = useState("");

  const activeRef = useRef();
  const inactiveRef = useRef();

  const [modal, setmodal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [configValue, setConfigValue] = useState(false);

  const reloadActiveRef = () => activeRef.current.setTokenAPI();
  const reloadInactiveRef = () => inactiveRef.current.setTokenAPI();

  return (
    <Fragment>
      <Container fluid>
        <Row>
          <Col xs="12">
            <PegawaiSideBar active="riwayat_pangkat" />

            <Card className="pegawai-rightbar">
              <CardBody>
                <div className="float-end">
                  {loading ? (
                    <div className="d-flex align-items-center gap-2">
                      <Spinner size="sm" color="primary" />
                      <span>Melakukan pengecekan konfigurasi...</span>
                    </div>
                  ) : (accessRole("approve") &&
                      employee_categories_uuid ===
                        "5c2e9672-248b-461d-b75d-c479aa39276c") ||
                    (configValue === 1 && role_id === 1) ? (
                    <Link to="home.html?riwayat_pangkat&create">
                      <Button color="primary">
                        Tambah Riwayat Kepangkatan
                      </Button>
                    </Link>
                  ) : null}
                </div>

                <CardTitle>List Data Riwayat Kepangkatan</CardTitle>
                <CardSubtitle className="mb-3">
                  {/* Daftar Urut Kepangkatan */}
                </CardSubtitle>
                <hr />

                <TableActiveComponent
                  ref={activeRef}
                  handleInactiveSuccess={reloadInactiveRef}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default IndexView;
